import React from "react";
import { IconProps } from "./IconProps";

const ThumbsDownIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.7359 12.2656L17.7984 4.76563C17.7413 4.31241 17.5208 3.89562 17.1781 3.59354C16.8354 3.29145 16.3943 3.12484 15.9375 3.125H2.5C2.16848 3.125 1.85054 3.2567 1.61612 3.49112C1.3817 3.72554 1.25 4.04348 1.25 4.375V11.25C1.25 11.5815 1.3817 11.8995 1.61612 12.1339C1.85054 12.3683 2.16848 12.5 2.5 12.5H5.86406L8.81563 18.4047C8.86759 18.5085 8.94744 18.5958 9.04625 18.6568C9.14505 18.7178 9.25889 18.7501 9.375 18.75C10.2038 18.75 10.9987 18.4208 11.5847 17.8347C12.1708 17.2487 12.5 16.4538 12.5 15.625V14.375H16.875C17.1411 14.3751 17.4041 14.3186 17.6467 14.2091C17.8892 14.0997 18.1057 13.94 18.2817 13.7404C18.4577 13.5409 18.5892 13.3062 18.6676 13.0519C18.7459 12.7976 18.7692 12.5296 18.7359 12.2656ZM5.625 11.25H2.5V4.375H5.625V11.25ZM17.3438 12.9133C17.2855 12.9803 17.2135 13.0339 17.1325 13.0704C17.0516 13.107 16.9638 13.1256 16.875 13.125H11.875C11.7092 13.125 11.5503 13.1908 11.4331 13.3081C11.3158 13.4253 11.25 13.5842 11.25 13.75V15.625C11.2501 16.0585 11.1 16.4787 10.8253 16.814C10.5505 17.1493 10.168 17.379 9.74297 17.4641L6.875 11.7273V4.375H15.9375C16.0898 4.37495 16.2368 4.43048 16.351 4.53118C16.4653 4.63187 16.5388 4.7708 16.5578 4.92188L17.4953 12.4219C17.507 12.5099 17.4995 12.5994 17.4734 12.6842C17.4472 12.769 17.403 12.8472 17.3438 12.9133Z"
            fill={color}
          />
        </svg>
      );
    case "32Reg":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M29.9775 19.625L28.4775 7.625C28.3861 6.89985 28.0332 6.233 27.485 5.74966C26.9367 5.26632 26.2309 4.99975 25.5 5H4C3.46957 5 2.96086 5.21071 2.58579 5.58579C2.21071 5.96086 2 6.46957 2 7V18C2 18.5304 2.21071 19.0391 2.58579 19.4142C2.96086 19.7893 3.46957 20 4 20H9.3825L14.105 29.4475C14.1881 29.6136 14.3159 29.7533 14.474 29.8509C14.6321 29.9485 14.8142 30.0001 15 30C16.3261 30 17.5979 29.4732 18.5355 28.5355C19.4732 27.5979 20 26.3261 20 25V23H27C27.4257 23.0001 27.8466 22.9097 28.2346 22.7346C28.6227 22.5596 28.9691 22.3039 29.2507 21.9847C29.5323 21.6655 29.7428 21.2899 29.8681 20.8831C29.9934 20.4762 30.0307 20.0474 29.9775 19.625ZM9 18H4V7H9V18ZM27.75 20.6612C27.6568 20.7685 27.5415 20.8542 27.4121 20.9127C27.2826 20.9712 27.142 21.001 27 21H19C18.7348 21 18.4804 21.1054 18.2929 21.2929C18.1054 21.4804 18 21.7348 18 22V25C18.0002 25.6936 17.76 26.3658 17.3204 26.9023C16.8808 27.4388 16.2689 27.8064 15.5887 27.9425L11 18.7638V7H25.5C25.7436 6.99992 25.9789 7.08877 26.1617 7.24989C26.3444 7.411 26.462 7.63328 26.4925 7.875L27.9925 19.875C28.0112 20.0158 27.9993 20.159 27.9574 20.2947C27.9155 20.4304 27.8448 20.5555 27.75 20.6612Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ThumbsDownIcon;
